import Vue from "vue";
import App from './App.vue';
import {Router} from '@/plugins/Router';
import {Store} from '@/plugins/Store';
import {I18n} from '@/plugins/I18n';
import {initSentry} from '@/plugins/Sentry';
import {Vuetify} from '@/plugins/Vuetify';
import './registerServiceWorker';
import {loadFilters} from "@/utils/filters";
// @ts-ignore
import CKEditorComponent from '@/components/ckeditor.js';
import {useMoment} from "@/plugins/Moment";
import {installLocalFirebaseAuthProxy} from "@/plugins/localFirebaseAuthProxy";

installLocalFirebaseAuthProxy();

const rn = document.getElementById('refreshNotice');
if (rn) {
    document.body.removeChild(rn);
}

initSentry();
loadFilters();
useMoment();
Vue.component('Ckeditor', CKEditorComponent);

// Dev error overlay — shows Vue render errors on screen instead of silent white screen
if (process.env.NODE_ENV !== 'production') {
    Vue.config.errorHandler = (err, vm, info) => {
        console.error('[Vue Error]', err, info);
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;padding:20px;background:#c0392b;color:#fff;z-index:99999;font-family:monospace;white-space:pre-wrap;max-height:50vh;overflow:auto';
        overlay.innerHTML = `<strong>Vue chyba (${info}):</strong>\n${err?.message}\n\n${err?.stack}`;
        document.body.appendChild(overlay);
    };
}

new Vue({
    router: Router,
    store: Store,
    i18n: I18n,
    vuetify: Vuetify,
    render: h => h(App)
}).$mount('#app');

const appEl = document.getElementById('app');
if (appEl) {
    appEl.classList.add('started');
}
